// Add to calendar: an .ics file for 1 session. It carries the hub's page for the product, not the
// Zoom link, so the link stays behind the login.
const pad = n => String(n).padStart(2, '0')
const icsTime = ms => {
  const d = new Date(ms)
  return `${d.getUTCFullYear()}${pad(d.getUTCMonth() + 1)}${pad(d.getUTCDate())}T${pad(d.getUTCHours())}${pad(d.getUTCMinutes())}00Z`
}
const esc = s => String(s).replace(/\\/g, '\\\\').replace(/;/g, '\\;').replace(/,/g, '\\,').replace(/\n/g, '\\n')

export function downloadIcs({ uid, title, startMs, endMs, path }) {
  const url = window.location.origin + path
  const ics = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//Adam Slee//Members//EN',
    'CALSCALE:GREGORIAN',
    'BEGIN:VEVENT',
    `UID:${uid}@${window.location.host}`,
    `DTSTAMP:${icsTime(Date.now())}`,
    `DTSTART:${icsTime(startMs)}`,
    `DTEND:${icsTime(endMs)}`,
    `SUMMARY:${esc(title)}`,
    `DESCRIPTION:${esc('Join from ' + url)}`,
    `URL:${url}`,
    'END:VEVENT',
    'END:VCALENDAR',
  ].join('\r\n')
  const blob = new Blob([ics], { type: 'text/calendar;charset=utf-8' })
  const href = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = href
  a.download = title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') + '.ics'
  document.body.appendChild(a)
  a.click()
  a.remove()
  setTimeout(() => URL.revokeObjectURL(href), 1000)
}

// Add to calendar for several sessions in 1 file (a secured place's "Add all 6 to your calendar"),
// each carrying the hub's page for the product, never a Zoom link.
export function downloadIcsAll({ name, events }) {
  const url = window.location.origin
  const body = events.map(e => [
    'BEGIN:VEVENT',
    `UID:${e.uid}@${window.location.host}`,
    `DTSTAMP:${icsTime(Date.now())}`,
    `DTSTART:${icsTime(e.startMs)}`,
    `DTEND:${icsTime(e.endMs)}`,
    `SUMMARY:${esc(e.title)}`,
    `DESCRIPTION:${esc('Join from ' + url + e.path)}`,
    `URL:${url + e.path}`,
    'END:VEVENT',
  ].join('\r\n'))
  const ics = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Adam Slee//Members//EN', 'CALSCALE:GREGORIAN', ...body, 'END:VCALENDAR'].join('\r\n')
  const blob = new Blob([ics], { type: 'text/calendar;charset=utf-8' })
  const href = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = href
  a.download = name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') + '.ics'
  document.body.appendChild(a)
  a.click()
  a.remove()
  setTimeout(() => URL.revokeObjectURL(href), 1000)
}
